<template>
  <div>
    <div class="modal modal--welcomeback modal--zero-balance " id="resubscribe_with_pin">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close" @click="$emit('close')"></i></button>
        <div class="modal__header">
        </div>
        <div class="modal__body">
          <h1>{{ getTranslations.home_modals_resubscribe_confirmation_you_are_not_subscribed }}</h1>
          <img class="modal_icon_main" src="static/images/resub-prize.png" alt="">
          <p>{{ getTranslations.home_modals_resubscribe_confirmation_in_order_to_unlock }}</p>
        </div>
        <div class="modal__footer">
          <a style="cursor:pointer" class="ti_btn--main" @click.prevent="reOptin">
            {{ getTranslations.home_modals_resubscribe_confirmation_resubscribe }}</a>
          <span class="terms">{{ getTranslations.home_modals_resubscribe_confirmation_by_clicking }} <br>
            <span class="make_it_bold">
              <a style="cursor:pointer" :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')"
                 target="_blank">{{ getTranslations.home_modals_resubscribe_confirmation_t_and_cs }}
            </a>
          </span> {{ getTranslations.home_modals_resubscribe_confirmation_of_the_service }}</span>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import IntegrationMixin from '@/common/mixins/integration';
import modals from '../../../common/modals';
import WelcomeReturningUnsub from './WelcomeReturningUnsub';
import ResubscribeViaPin from './ResubscribeViaPin';
import ResubscribeError from './store/ConfirmPurchaseForPinError';

export default {
  // modal_resubscribe_purchase_trial.html
  name: 'resubscribe-game',
  mixins: [IntegrationMixin],
  data() {
    return {
      showedModal: false,
    };
  },
  methods: {
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapMutations('common', [
      'storeModalForStore',
      'storeModalForSettings',
      'storeModalForHomePage',
    ]),
    ...mapActions('common', [
      'reOptinProcess',
    ]),
    showResubModal(modal) {
      if (sessionStorage.getItem('homeCurrentTabPath') === '/home/store') {
        this.storeModalForStore(modal);
        modals.showHideModalForHomeStorePage(this);
      } else if (sessionStorage.getItem('homeCurrentTabPath') === '/home/profile/edit') {
        this.storeModalForSettings(modal);
        modals.showHideModalForHomePage(this);
      } else {
        this.storeModalForHomePage(modal);
        modals.showHideModal(this);
      }
    },
    reSubCallback(response) {
      if (response.data.responseEnum === 'OPERATION_SUCCESS') {
        this.getUserLoginDetails().then(() => {
          if (this.userDetails.operatorName === 'ZAIN_KSA' && this.integrationHeader === this.availableIntegrations.KSA_MOBILY.name) {
            const scriptToAdd = document.createElement('script');
            scriptToAdd.type = 'text/javascript';
            scriptToAdd.async = true;
            scriptToAdd.setAttribute('src', 'https://fd.sla-alacrity.com/d513e9e03227.js');
            document.head.appendChild(scriptToAdd);
          }
          if (this.reoptinOnestep) {
            if (this.userDetails.subscribed) {
              this.showResubModal(WelcomeReturningUnsub);
            } else {
              this.showResubModal(ResubscribeError);
            }
          } else {
            // eslint-disable-next-line
            if (!this.userDetails.subscribed) {
              this.showResubModal(ResubscribeViaPin);
            } else {
              this.showResubModal(ResubscribeError);
            }
          }
        });
      } else {
        this.showResubModal(ResubscribeError);
      }
    },
    reOptin() {
      // eslint-disable-next-line
      console.log('Resubscribe user Call');
      this.getAppropriateReSubAction();
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'reoptinOnestep',
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/modals/ResubscribeGame.vue